/* Mega menu: ograniczenie liczby podkategorii z przyciskiem 'pokaz wiecej'
 * Przeniesione z main.js podczas migracji Beautify 1.0.2 -> 1.3.0 */

// Mega menu: ogranicz liczbę podkategorii z "pokaż więcej"
document.addEventListener('DOMContentLoaded', function() {
  if (window.innerWidth < 1024) return; // tylko desktop

  const LIMIT = 5;
  document.querySelectorAll('.mega-nav__grid .child-nav > li').forEach(function(col) {
    const grandchild = col.querySelector('.main-nav__grandchild');
    if (!grandchild) return;
    
    const items = grandchild.querySelectorAll('li');
    if (items.length <= LIMIT) return;
    items.forEach(function(item, i) {
      if (i >= LIMIT) item.style.display = 'none';
    });
    const btn = document.createElement('button');
    btn.textContent = '+ Pokaż więcej';
    btn.style.cssText = 'background:none;border:none;color:#945751;cursor:pointer;font-size:12px;padding:4px 0;text-align:left;display:block;margin-top:4px;';
    btn.addEventListener('click', function() {
      items.forEach(function(item) {
        item.style.display = '';
      });
      btn.remove();
    });
    grandchild.appendChild(btn);
  });
});
